module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ts-button",
    class: ['ts-button--' + _vm.type, 'ts-button--' + _vm.size, {
      'is-disabled': _vm.disabled
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled,
      "title": _vm.title
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleClick($event)
      }
    }
  }, [(_vm.icon || _vm.$slots.icon) ? _c('span', {
    staticClass: "ts-button-icon"
  }, [_vm._t("icon", [_vm._v("\"iconfont-\"+icon}>")])], 2) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ts-button-text"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-55022bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsButton.vue
// module id = 832
// module chunks = 39